<template>
    <input class="form-control" type="text" v-pml-mask="'datetime'" />
</template>

<style src="eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css"></style>

<script>
    import 'eonasdan-bootstrap-datetimepicker'
    import moment from 'moment'
    import { isEmpty } from 'lodash'
    import { utcToLocal, utcOffset } from 'utils/helpers/dates' /*, utcOffset */

    export default {
        name: 'DatetimePicker',
        props: {
            value: {
                type: String,
                default: () => ''
            },
            universalFormat: {
                type: String,
                required: false,
                default: 'YYYY[-]MM[-]DD HH:mm:ss'
            },
            humanFormat: {
                type: String,
                required: false,
                default: 'DD/MM/YYYY HH:mm'
            },
            viewMode: {
                type: String,
                required: false,
                default: 'days'
            }
        },
        data () {
            return {
                control: null
            }
        },
        watch: {
            value (val) {
                let incomingDate = moment()

                if (moment(val, this.universalFormat).format(this.universalFormat) === val)
                    incomingDate = moment(val, this.universalFormat)
                else if (moment(val, this.humanFormat).format(this.humanFormat) === val)
                    incomingDate = moment(val, this.humanFormat)

                let localDate = utcToLocal(incomingDate.format(this.universalFormat), this.universalFormat)

                if (localDate.format(this.humanFormat) !== this.getDatetime())
                    this.control.date(moment(localDate.format(this.humanFormat), this.humanFormat))

                if (val === '')
                    this.control.date(null)
            }
        },
        mounted () {
            var options = {
                useCurrent: false,
                showClear: true,
                showTodayButton: true,
                sideBySide: true,
                format: this.humanFormat,
                viewMode: this.viewMode,
                locale: this.locale,
                toolbarPlacement: 'bottom'
            }

            window.jQuery(this.$el).datetimepicker(options).on('dp.change', (e) => {
                if (e.date.format)
                    this.$emit('input', utcOffset(e.date.format(this.universalFormat)).format(this.humanFormat))
                if (!e.date)
                    this.$emit('input', '')
            })

            this.control = window.jQuery(this.$el).data('DateTimePicker')
        },
        computed: {
            locale () {
                const storedLang = window.localStorage.getItem('pml_lang')
                return isEmpty(storedLang) ? 'en-us' : storedLang.toLowerCase()
            }
        },
        methods: {
            getDatetime () {
                return this.control.date() !== null ? this.control.date().format(this.humanFormat) : null
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/form/DatetimePicker.vue